import { Box, Button, Flex, FlexProps } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { useShowCache, useUserCache } from 'src/apollo/cache';
import { Host } from 'src/generated/graphql';
import Icons from 'src/components/menu/Icons';
import { isAdminImpersonating } from 'src/utils/impersonation';
import { useMenuContext } from '../MenuContext';
import NavButton from './components/NavButton';
import NavButtonsContainer from './components/NavButtonsContainer';
import useLogout from './hooks/useLogout';

const buttonContainerProps = {
  position: 'absolute',
  left: '12px',
} as Partial<FlexProps>;

export function MenuHeader() {
  const [menuState] = useMenuContext();
  const show = useShowCache();
  const isImpersonatingAdmin = isAdminImpersonating();

  const isClosed = menuState === 'closed';

  return (
    <Box>
      {isImpersonatingAdmin && <ImpersonationIndicator isClosed={isClosed} />}
      {isClosed ? <AlituLogoWithoutText /> : <AlituLogoWithText />}
      <NavButtonsContainer {...(isClosed ? buttonContainerProps : {})}>
        <NavButton page="episodes" />
        <NavButton page="call-recorder" />
        <NavButton page="clip-genie" />
        <NavButton page="library" />
        {show?.host === Host.Alitu && <NavButton page="statistics" />}
      </NavButtonsContainer>
    </Box>
  );
}

function AlituLogoWithText() {
  const navigate = useNavigate();

  return (
    <Box mb="30px" pl="16px">
      <button type="button" onClick={() => navigate('/episodes')}>
        <Icons.AlituLogoWithText />
      </button>
    </Box>
  );
}

function AlituLogoWithoutText() {
  const navigate = useNavigate();

  return (
    <Flex mb="18px" justifyContent="center">
      <button type="button" onClick={() => navigate('/episodes')}>
        <Icons.AlituLogoWithoutText />
      </button>
    </Flex>
  );
}

// A small yellow button that appears when an admin is impersonating a user
function ImpersonationIndicator({ isClosed }: { isClosed: boolean }) {
  const user = useUserCache();

  const logout = useLogout();

  if (isClosed) {
    return (
      <Box position="absolute" left="12px" top="30px" w="50px" textAlign="center">
        <Button
          bg="podcastYellow"
          p="2px"
          borderRadius="4px"
          size="sm"
          onClick={() => logout()}
          color="black"
        >
          {user?.id}
        </Button>
      </Box>
    );
  }

  return (
    <Button
      position="absolute"
      bg="podcastYellow"
      p="2px"
      borderRadius="4px"
      left="170px"
      size="sm"
      top="30px"
      onClick={() => logout()}
      color="black"
    >
      user <br />
      {user?.id}
    </Button>
  );
}
